import { gql } from '@apollo/client'
import { BodyText, Chip, Heading, RadioCard, Subtitle } from '@farol-ds/react'

import { PlanOfferCards_OfferLockDataFragment } from './__generated__/plan-offer-cards.graphql'
import styles from './third-party-background-check-lock.module.scss'

interface PlanOfferCardProps {
  offerLockData: PlanOfferCards_OfferLockDataFragment
}
type Card = PlanOfferCards_OfferLockDataFragment['body']['cards'][number]

export default function PlanOfferCards({ offerLockData }: PlanOfferCardProps) {
  const { body } = offerLockData || {}
  const { cards } = body || {}
  return (
    <>
      {cards.map((card: Card, index: number) => (
        <RadioCard
          key={`third-party-background-check-lock-card-${index}`}
          orientation="vertical"
          value={`${index}`}
        >
          <RadioCard.Content>
            {index === cards.length - 1 && (
              <Chip className={styles.thirdPartyBackgroundCheckLockChip} size="sm" kind="secondary">
                Economize 50%
              </Chip>
            )}
            <RadioCard.ContentTitle
              className={styles.thirdPartyBackgroundCheckLockCardContentTitle}
            >
              <Heading className={styles.thirdPartyBackgroundCheckLockCardTitle} size="md">
                {card.title}
              </Heading>{' '}
              <Subtitle className={styles.thirdPartyBackgroundCheckLockCardSubtitle} size="md">
                {card.subtitle}
              </Subtitle>
            </RadioCard.ContentTitle>
            <RadioCard.ContentDescription>
              <BodyText size="md">
                <strong>{card.offer.priceText}</strong>
              </BodyText>
            </RadioCard.ContentDescription>
          </RadioCard.Content>
        </RadioCard>
      ))}
    </>
  )
}

PlanOfferCards.fragments = {
  offerLockData: gql`
    fragment PlanOfferCards_offerLockData on OfferLockData {
      body {
        cards {
          title
          subtitle
          offer {
            frequencyPeriodText
            priceText
            frequency
          }
          button {
            label
          }
        }
      }
    }
  `,
}
